import { render, staticRenderFns } from "./instances.vue?vue&type=template&id=0241be08&scoped=true&"
import script from "./instances.vue?vue&type=script&lang=js&"
export * from "./instances.vue?vue&type=script&lang=js&"
import style0 from "./instances.vue?vue&type=style&index=0&id=0241be08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0241be08",
  null
  
)

export default component.exports